// extracted by mini-css-extract-plugin
export var blueBanner = "faq-module--blueBanner--A4sgu";
export var container = "faq-module--container--GWmSA";
export var header = "faq-module--header--II5-B";
export var main = "faq-module--main--UuYyY";
export var mainPadding = "faq-module--mainPadding--9BhOa";
export var mainRaised = "faq-module--mainRaised--U4Xxb";
export var space100 = "faq-module--space100--+mXUO";
export var space50 = "faq-module--space50--Lh9Mm";
export var statement = "faq-module--statement--t2VOU";